// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoleSelectorStage__cards--futSE {
    width: 100%;
    max-width: 896px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 64px;
}

    .RoleSelectorStage__cards--futSE.RoleSelectorStage__primary--SVD3S .RoleSelectorStage__radioButtons--nWV09 {
            padding: 0 23px;
        }

    @media screen and (max-width: 1023px) {

    .RoleSelectorStage__cards--futSE.RoleSelectorStage__primary--SVD3S .RoleSelectorStage__radioButtons--nWV09 {
                width: calc(100% + 32px);
                margin-left: -16px
        }
            }

    .RoleSelectorStage__cards--futSE.RoleSelectorStage__secondary--Bjku0 {
        grid-gap: 20px;
        max-width: 640px;
    }

.RoleSelectorStage__card--MDHrR {
    width: 100%;
}

.RoleSelectorStage__cardImage--YCjG6 {
    width: 100%;
    height: auto;
    max-width: 246px;
    margin: 0 auto;
    margin-bottom: 16px;
    aspect-ratio: 0.64;
    border-radius: 6px;
}

.RoleSelectorStage__radioButtons--nWV09 {
    display: flex;
    gap: 8px;
}

@media screen and (max-width: 1023px) {

.RoleSelectorStage__radioButtons--nWV09 {
        width: calc(100% + 48px);
        margin-left: -24px;
        justify-content: center
}
    }

@media screen and (min-width: 1024px) {

.RoleSelectorStage__radioButtons--nWV09 {
        flex-direction: column;
        width: 100%
}
    }
`, "",{"version":3,"sources":["webpack://./src/components/RoleSelectorStage/RoleSelectorStage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,cAAc;AAiBlB;;IAdQ;YACI,eAAe;QAMnB;;IAJI;;IAHJ;gBAIQ,wBAAwB;gBACxB;QAER;YADI;;IAIR;QACI,cAAc;QACd,gBAAgB;IACpB;;AAGJ;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AAYZ;;AAVI;;AAJJ;QAKQ,wBAAwB;QACxB,kBAAkB;QAClB;AAOR;IANI;;AAEA;;AAVJ;QAWQ,sBAAsB;QACtB;AAER;IADI","sourcesContent":[".cards {\n    width: 100%;\n    max-width: 896px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 64px;\n\n    &.primary {\n        .radioButtons {\n            padding: 0 23px;\n\n            @media (--mobile) {\n                width: calc(100% + 32px);\n                margin-left: -16px;\n            }\n        }\n    }\n\n    &.secondary {\n        grid-gap: 20px;\n        max-width: 640px;\n    }\n}\n\n.card {\n    width: 100%;\n}\n\n.cardImage {\n    width: 100%;\n    height: auto;\n    max-width: 246px;\n    margin: 0 auto;\n    margin-bottom: 16px;\n    aspect-ratio: 0.64;\n    border-radius: 6px;\n}\n\n.radioButtons {\n    display: flex;\n    gap: 8px;\n\n    @media (--mobile) {\n        width: calc(100% + 48px);\n        margin-left: -24px;\n        justify-content: center;\n    }\n\n    @media (--large) {\n        flex-direction: column;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cards": `RoleSelectorStage__cards--futSE`,
	"primary": `RoleSelectorStage__primary--SVD3S`,
	"radioButtons": `RoleSelectorStage__radioButtons--nWV09`,
	"secondary": `RoleSelectorStage__secondary--Bjku0`,
	"card": `RoleSelectorStage__card--MDHrR`,
	"cardImage": `RoleSelectorStage__cardImage--YCjG6`
};
export default ___CSS_LOADER_EXPORT___;
